import { useCallback } from "react";

import type { DesignerEffect } from "../../types";
import { useResponseDesigner } from "../ResponseByIdContext";

type EffectDesignerProps = {
  effect: DesignerEffect;
  view?: "summary" | "edit";
};

// equivalent of NodeDesigner component
export const EffectDesigner = ({ effect: { builder, id, spec, config }, view = "edit" }: EffectDesignerProps) => {
  const { updateEffect } = useResponseDesigner();
  const Component = builder.views[view];

  const handleConfigChange = useCallback(
    (newConfig: unknown) => {
      updateEffect(id, newConfig);
    },
    [id, updateEffect],
  );

  return <Component key={id} spec={spec} config={config} onConfigChange={handleConfigChange} />;
};
